import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["value", "defaultValue", "name", "onChange", "by", "disabled", "horizontal", "multiple"],
    _excluded2 = ["id"],
    _excluded3 = ["id"],
    _excluded4 = ["id"],
    _excluded5 = ["id", "disabled", "value"];

var _Ge;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import N, { Fragment as be, createContext as Y, createRef as xe, useCallback as ye, useContext as Z, useEffect as ee, useMemo as h, useReducer as ge, useRef as D } from "react";
import { useDisposables as j } from '../../hooks/use-disposables.js';
import { useId as V } from '../../hooks/use-id.js';
import { useIsoMorphicEffect as K } from '../../hooks/use-iso-morphic-effect.js';
import { useComputed as te } from '../../hooks/use-computed.js';
import { useSyncRefs as k } from '../../hooks/use-sync-refs.js';
import { Features as oe, forwardRefWithAs as w, render as _, compact as Le } from '../../utils/render.js';
import { match as I } from '../../utils/match.js';
import { disposables as X } from '../../utils/disposables.js';
import { Keys as y } from '../keyboard.js';
import { Focus as R, calculateActiveIndex as Oe } from '../../utils/calculate-active-index.js';
import { isDisabledReactIssue7711 as me } from '../../utils/bugs.js';
import { isFocusableElement as Re, FocusableMode as ve, sortByDomNode as Ae } from '../../utils/focus-management.js';
import { useOpenClosed as Se, State as Q, OpenClosedProvider as Pe } from '../../internal/open-closed.js';
import { useResolveButtonType as Ee } from '../../hooks/use-resolve-button-type.js';
import { useOutsideClick as he } from '../../hooks/use-outside-click.js';
import { Hidden as De, Features as Ie } from '../../internal/hidden.js';
import { objectToFormEntries as Ce } from '../../utils/form.js';
import { getOwnerDocument as Fe } from '../../utils/owner.js';
import { useEvent as T } from '../../hooks/use-event.js';
import { useControllable as Me } from '../../hooks/use-controllable.js';
import { useLatestValue as ke } from '../../hooks/use-latest-value.js';
import { useTrackedPointer as we } from '../../hooks/use-tracked-pointer.js';

var _e = function (o) {
  return o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o;
}(_e || {}),
    Ue = function (o) {
  return o[o.Single = 0] = "Single", o[o.Multi = 1] = "Multi", o;
}(Ue || {}),
    Be = function (o) {
  return o[o.Pointer = 0] = "Pointer", o[o.Other = 1] = "Other", o;
}(Be || {}),
    He = function (i) {
  return i[i.OpenListbox = 0] = "OpenListbox", i[i.CloseListbox = 1] = "CloseListbox", i[i.GoToOption = 2] = "GoToOption", i[i.Search = 3] = "Search", i[i.ClearSearch = 4] = "ClearSearch", i[i.RegisterOption = 5] = "RegisterOption", i[i.UnregisterOption = 6] = "UnregisterOption", i[i.RegisterLabel = 7] = "RegisterLabel", i;
}(He || {});

function $(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (o) {
    return o;
  };
  var o = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null,
      n = Ae(r(e.options.slice()), function (t) {
    return t.dataRef.current.domRef.current;
  }),
      a = o ? n.indexOf(o) : null;
  return a === -1 && (a = null), {
    options: n,
    activeOptionIndex: a
  };
}

var Ge = (_Ge = {}, _defineProperty(_Ge, 1, function _(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
    activeOptionIndex: null,
    listboxState: 1
  });
}), _defineProperty(_Ge, 0, function _(e) {
  if (e.dataRef.current.disabled || e.listboxState === 0) return e;
  var r = e.activeOptionIndex,
      o = e.dataRef.current.isSelected,
      n = e.options.findIndex(function (a) {
    return o(a.dataRef.current.value);
  });
  return n !== -1 && (r = n), _objectSpread(_objectSpread({}, e), {}, {
    listboxState: 0,
    activeOptionIndex: r
  });
}), _defineProperty(_Ge, 2, function _(e, r) {
  var a;
  if (e.dataRef.current.disabled || e.listboxState === 1) return e;
  var o = $(e),
      n = Oe(r, {
    resolveItems: function resolveItems() {
      return o.options;
    },
    resolveActiveIndex: function resolveActiveIndex() {
      return o.activeOptionIndex;
    },
    resolveId: function resolveId(t) {
      return t.id;
    },
    resolveDisabled: function resolveDisabled(t) {
      return t.dataRef.current.disabled;
    }
  });
  return _objectSpread(_objectSpread(_objectSpread({}, e), o), {}, {
    searchQuery: "",
    activeOptionIndex: n,
    activationTrigger: (a = r.trigger) != null ? a : 1
  });
}), _defineProperty(_Ge, 3, function _(e, r) {
  if (e.dataRef.current.disabled || e.listboxState === 1) return e;
  var n = e.searchQuery !== "" ? 0 : 1,
      a = e.searchQuery + r.value.toLowerCase(),
      u = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + n).concat(e.options.slice(0, e.activeOptionIndex + n)) : e.options).find(function (i) {
    var b;
    return !i.dataRef.current.disabled && ((b = i.dataRef.current.textValue) == null ? void 0 : b.startsWith(a));
  }),
      c = u ? e.options.indexOf(u) : -1;
  return c === -1 || c === e.activeOptionIndex ? _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: a
  }) : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: a,
    activeOptionIndex: c,
    activationTrigger: 1
  });
}), _defineProperty(_Ge, 4, function _(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: ""
  });
}), _defineProperty(_Ge, 5, function _(e, r) {
  var o = {
    id: r.id,
    dataRef: r.dataRef
  },
      n = $(e, function (a) {
    return [].concat(_toConsumableArray(a), [o]);
  });
  return e.activeOptionIndex === null && e.dataRef.current.isSelected(r.dataRef.current.value) && (n.activeOptionIndex = n.options.indexOf(o)), _objectSpread(_objectSpread({}, e), n);
}), _defineProperty(_Ge, 6, function _(e, r) {
  var o = $(e, function (n) {
    var a = n.findIndex(function (t) {
      return t.id === r.id;
    });
    return a !== -1 && n.splice(a, 1), n;
  });
  return _objectSpread(_objectSpread(_objectSpread({}, e), o), {}, {
    activationTrigger: 1
  });
}), _defineProperty(_Ge, 7, function _(e, r) {
  return _objectSpread(_objectSpread({}, e), {}, {
    labelId: r.id
  });
}), _Ge),
    z = Y(null);
z.displayName = "ListboxActionsContext";

function U(e) {
  var r = Z(z);

  if (r === null) {
    var o = new Error("<".concat(e, " /> is missing a parent <Listbox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, U), o;
  }

  return r;
}

var J = Y(null);
J.displayName = "ListboxDataContext";

function B(e) {
  var r = Z(J);

  if (r === null) {
    var o = new Error("<".concat(e, " /> is missing a parent <Listbox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, B), o;
  }

  return r;
}

function Ne(e, r) {
  return I(r.type, Ge, e, r);
}

var je = be;

function Ve(e, r) {
  var _I3;

  var o = e.value,
      n = e.defaultValue,
      a = e.name,
      t = e.onChange,
      _e$by = e.by,
      u = _e$by === void 0 ? function (s, f) {
    return s === f;
  } : _e$by,
      _e$disabled = e.disabled,
      c = _e$disabled === void 0 ? !1 : _e$disabled,
      _e$horizontal = e.horizontal,
      i = _e$horizontal === void 0 ? !1 : _e$horizontal,
      _e$multiple = e.multiple,
      b = _e$multiple === void 0 ? !1 : _e$multiple,
      A = _objectWithoutProperties(e, _excluded);

  var m = i ? "horizontal" : "vertical";

  var P = k(r),
      _Me = Me(o, t, n),
      _Me2 = _slicedToArray(_Me, 2),
      _Me2$ = _Me2[0],
      g = _Me2$ === void 0 ? b ? [] : void 0 : _Me2$,
      v = _Me2[1],
      _ge = ge(Ne, {
    dataRef: xe(),
    listboxState: 1,
    options: [],
    searchQuery: "",
    labelId: null,
    activeOptionIndex: null,
    activationTrigger: 1
  }),
      _ge2 = _slicedToArray(_ge, 2),
      S = _ge2[0],
      p = _ge2[1],
      l = D({
    static: !1,
    hold: !1
  }),
      x = D(null),
      E = D(null),
      W = D(null),
      C = T(typeof u == "string" ? function (s, f) {
    var O = u;
    return (s == null ? void 0 : s[O]) === (f == null ? void 0 : f[O]);
  } : u),
      L = ye(function (s) {
    var _I;

    return I(d.mode, (_I = {}, _defineProperty(_I, 1, function _() {
      return g.some(function (f) {
        return C(f, s);
      });
    }), _defineProperty(_I, 0, function _() {
      return C(g, s);
    }), _I));
  }, [g]),
      d = h(function () {
    return _objectSpread(_objectSpread({}, S), {}, {
      value: g,
      disabled: c,
      mode: b ? 1 : 0,
      orientation: m,
      compare: C,
      isSelected: L,
      optionsPropsRef: l,
      labelRef: x,
      buttonRef: E,
      optionsRef: W
    });
  }, [g, c, b, S]);

  K(function () {
    S.dataRef.current = d;
  }, [d]), he([d.buttonRef, d.optionsRef], function (s, f) {
    var O;
    p({
      type: 1
    }), Re(f, ve.Loose) || (s.preventDefault(), (O = d.buttonRef.current) == null || O.focus());
  }, d.listboxState === 0);
  var H = h(function () {
    return {
      open: d.listboxState === 0,
      disabled: c,
      value: g
    };
  }, [d, c, g]),
      ne = T(function (s) {
    var f = d.options.find(function (O) {
      return O.id === s;
    });
    f && F(f.dataRef.current.value);
  }),
      ie = T(function () {
    if (d.activeOptionIndex !== null) {
      var _d$options$d$activeOp = d.options[d.activeOptionIndex],
          s = _d$options$d$activeOp.dataRef,
          f = _d$options$d$activeOp.id;
      F(s.current.value), p({
        type: 2,
        focus: R.Specific,
        id: f
      });
    }
  }),
      re = T(function () {
    return p({
      type: 0
    });
  }),
      ae = T(function () {
    return p({
      type: 1
    });
  }),
      le = T(function (s, f, O) {
    return s === R.Specific ? p({
      type: 2,
      focus: R.Specific,
      id: f,
      trigger: O
    }) : p({
      type: 2,
      focus: s,
      trigger: O
    });
  }),
      se = T(function (s, f) {
    return p({
      type: 5,
      id: s,
      dataRef: f
    }), function () {
      return p({
        type: 6,
        id: s
      });
    };
  }),
      pe = T(function (s) {
    return p({
      type: 7,
      id: s
    }), function () {
      return p({
        type: 7,
        id: null
      });
    };
  }),
      F = T(function (s) {
    var _I2;

    return I(d.mode, (_I2 = {}, _defineProperty(_I2, 0, function _() {
      return v == null ? void 0 : v(s);
    }), _defineProperty(_I2, 1, function _() {
      var f = d.value.slice(),
          O = f.findIndex(function (M) {
        return C(M, s);
      });
      return O === -1 ? f.push(s) : f.splice(O, 1), v == null ? void 0 : v(f);
    }), _I2));
  }),
      ue = T(function (s) {
    return p({
      type: 3,
      value: s
    });
  }),
      de = T(function () {
    return p({
      type: 4
    });
  }),
      ce = h(function () {
    return {
      onChange: F,
      registerOption: se,
      registerLabel: pe,
      goToOption: le,
      closeListbox: ae,
      openListbox: re,
      selectActiveOption: ie,
      selectOption: ne,
      search: ue,
      clearSearch: de
    };
  }, []),
      fe = {
    ref: P
  },
      G = D(null),
      Te = j();
  return ee(function () {
    G.current && n !== void 0 && Te.addEventListener(G.current, "reset", function () {
      F(n);
    });
  }, [G, F]), N.createElement(z.Provider, {
    value: ce
  }, N.createElement(J.Provider, {
    value: d
  }, N.createElement(Pe, {
    value: I(d.listboxState, (_I3 = {}, _defineProperty(_I3, 0, Q.Open), _defineProperty(_I3, 1, Q.Closed), _I3))
  }, a != null && g != null && Ce(_defineProperty({}, a, g)).map(function (_ref, O) {
    var _ref2 = _slicedToArray(_ref, 2),
        s = _ref2[0],
        f = _ref2[1];

    return N.createElement(De, _objectSpread({
      features: Ie.Hidden,
      ref: O === 0 ? function (M) {
        var q;
        G.current = (q = M == null ? void 0 : M.closest("form")) != null ? q : null;
      } : void 0
    }, Le({
      key: s,
      as: "input",
      type: "hidden",
      hidden: !0,
      readOnly: !0,
      name: s,
      value: f
    })));
  }), _({
    ourProps: fe,
    theirProps: A,
    slot: H,
    defaultTag: je,
    name: "Listbox"
  }))));
}

var Ke = "button";

function Qe(e, r) {
  var S;

  var o = V(),
      _e$id = e.id,
      n = _e$id === void 0 ? "headlessui-listbox-button-".concat(o) : _e$id,
      a = _objectWithoutProperties(e, _excluded2),
      t = B("Listbox.Button"),
      u = U("Listbox.Button"),
      c = k(t.buttonRef, r),
      i = j(),
      b = T(function (p) {
    switch (p.key) {
      case y.Space:
      case y.Enter:
      case y.ArrowDown:
        p.preventDefault(), u.openListbox(), i.nextFrame(function () {
          t.value || u.goToOption(R.First);
        });
        break;

      case y.ArrowUp:
        p.preventDefault(), u.openListbox(), i.nextFrame(function () {
          t.value || u.goToOption(R.Last);
        });
        break;
    }
  }),
      A = T(function (p) {
    switch (p.key) {
      case y.Space:
        p.preventDefault();
        break;
    }
  }),
      m = T(function (p) {
    if (me(p.currentTarget)) return p.preventDefault();
    t.listboxState === 0 ? (u.closeListbox(), i.nextFrame(function () {
      var l;
      return (l = t.buttonRef.current) == null ? void 0 : l.focus({
        preventScroll: !0
      });
    })) : (p.preventDefault(), u.openListbox());
  }),
      P = te(function () {
    if (t.labelId) return [t.labelId, n].join(" ");
  }, [t.labelId, n]),
      g = h(function () {
    return {
      open: t.listboxState === 0,
      disabled: t.disabled,
      value: t.value
    };
  }, [t]),
      v = {
    ref: c,
    id: n,
    type: Ee(e, t.buttonRef),
    "aria-haspopup": "listbox",
    "aria-controls": (S = t.optionsRef.current) == null ? void 0 : S.id,
    "aria-expanded": t.disabled ? void 0 : t.listboxState === 0,
    "aria-labelledby": P,
    disabled: t.disabled,
    onKeyDown: b,
    onKeyUp: A,
    onClick: m
  };

  return _({
    ourProps: v,
    theirProps: a,
    slot: g,
    defaultTag: Ke,
    name: "Listbox.Button"
  });
}

var We = "label";

function Xe(e, r) {
  var o = V(),
      _e$id2 = e.id,
      n = _e$id2 === void 0 ? "headlessui-listbox-label-".concat(o) : _e$id2,
      a = _objectWithoutProperties(e, _excluded3),
      t = B("Listbox.Label"),
      u = U("Listbox.Label"),
      c = k(t.labelRef, r);

  K(function () {
    return u.registerLabel(n);
  }, [n]);
  var i = T(function () {
    var m;
    return (m = t.buttonRef.current) == null ? void 0 : m.focus({
      preventScroll: !0
    });
  }),
      b = h(function () {
    return {
      open: t.listboxState === 0,
      disabled: t.disabled
    };
  }, [t]);
  return _({
    ourProps: {
      ref: c,
      id: n,
      onClick: i
    },
    theirProps: a,
    slot: b,
    defaultTag: We,
    name: "Listbox.Label"
  });
}

var $e = "ul",
    ze = oe.RenderStrategy | oe.Static;

function Je(e, r) {
  var p;

  var o = V(),
      _e$id3 = e.id,
      n = _e$id3 === void 0 ? "headlessui-listbox-options-".concat(o) : _e$id3,
      a = _objectWithoutProperties(e, _excluded4),
      t = B("Listbox.Options"),
      u = U("Listbox.Options"),
      c = k(t.optionsRef, r),
      i = j(),
      b = j(),
      A = Se(),
      m = function () {
    return A !== null ? (A & Q.Open) === Q.Open : t.listboxState === 0;
  }();

  ee(function () {
    var x;
    var l = t.optionsRef.current;
    l && t.listboxState === 0 && l !== ((x = Fe(l)) == null ? void 0 : x.activeElement) && l.focus({
      preventScroll: !0
    });
  }, [t.listboxState, t.optionsRef]);
  var P = T(function (l) {
    switch (b.dispose(), l.key) {
      case y.Space:
        if (t.searchQuery !== "") return l.preventDefault(), l.stopPropagation(), u.search(l.key);

      case y.Enter:
        if (l.preventDefault(), l.stopPropagation(), t.activeOptionIndex !== null) {
          var x = t.options[t.activeOptionIndex].dataRef;
          u.onChange(x.current.value);
        }

        t.mode === 0 && (u.closeListbox(), X().nextFrame(function () {
          var x;
          return (x = t.buttonRef.current) == null ? void 0 : x.focus({
            preventScroll: !0
          });
        }));
        break;

      case I(t.orientation, {
        vertical: y.ArrowDown,
        horizontal: y.ArrowRight
      }):
        return l.preventDefault(), l.stopPropagation(), u.goToOption(R.Next);

      case I(t.orientation, {
        vertical: y.ArrowUp,
        horizontal: y.ArrowLeft
      }):
        return l.preventDefault(), l.stopPropagation(), u.goToOption(R.Previous);

      case y.Home:
      case y.PageUp:
        return l.preventDefault(), l.stopPropagation(), u.goToOption(R.First);

      case y.End:
      case y.PageDown:
        return l.preventDefault(), l.stopPropagation(), u.goToOption(R.Last);

      case y.Escape:
        return l.preventDefault(), l.stopPropagation(), u.closeListbox(), i.nextFrame(function () {
          var x;
          return (x = t.buttonRef.current) == null ? void 0 : x.focus({
            preventScroll: !0
          });
        });

      case y.Tab:
        l.preventDefault(), l.stopPropagation();
        break;

      default:
        l.key.length === 1 && (u.search(l.key), b.setTimeout(function () {
          return u.clearSearch();
        }, 350));
        break;
    }
  }),
      g = te(function () {
    var l, x, E;
    return (E = (l = t.labelRef.current) == null ? void 0 : l.id) != null ? E : (x = t.buttonRef.current) == null ? void 0 : x.id;
  }, [t.labelRef.current, t.buttonRef.current]),
      v = h(function () {
    return {
      open: t.listboxState === 0
    };
  }, [t]),
      S = {
    "aria-activedescendant": t.activeOptionIndex === null || (p = t.options[t.activeOptionIndex]) == null ? void 0 : p.id,
    "aria-multiselectable": t.mode === 1 ? !0 : void 0,
    "aria-labelledby": g,
    "aria-orientation": t.orientation,
    id: n,
    onKeyDown: P,
    role: "listbox",
    tabIndex: 0,
    ref: c
  };
  return _({
    ourProps: S,
    theirProps: a,
    slot: v,
    defaultTag: $e,
    features: ze,
    visible: m,
    name: "Listbox.Options"
  });
}

var qe = "li";

function Ye(e, r) {
  var o = V(),
      _e$id4 = e.id,
      n = _e$id4 === void 0 ? "headlessui-listbox-option-".concat(o) : _e$id4,
      _e$disabled2 = e.disabled,
      a = _e$disabled2 === void 0 ? !1 : _e$disabled2,
      t = e.value,
      u = _objectWithoutProperties(e, _excluded5),
      c = B("Listbox.Option"),
      i = U("Listbox.Option"),
      b = c.activeOptionIndex !== null ? c.options[c.activeOptionIndex].id === n : !1,
      A = c.isSelected(t),
      m = D(null),
      P = ke({
    disabled: a,
    value: t,
    domRef: m,

    get textValue() {
      var L, d;
      return (d = (L = m.current) == null ? void 0 : L.textContent) == null ? void 0 : d.toLowerCase();
    }

  }),
      g = k(r, m);

  K(function () {
    if (c.listboxState !== 0 || !b || c.activationTrigger === 0) return;
    var L = X();
    return L.requestAnimationFrame(function () {
      var d, H;
      (H = (d = m.current) == null ? void 0 : d.scrollIntoView) == null || H.call(d, {
        block: "nearest"
      });
    }), L.dispose;
  }, [m, b, c.listboxState, c.activationTrigger, c.activeOptionIndex]), K(function () {
    return i.registerOption(n, P);
  }, [P, n]);
  var v = T(function (L) {
    if (a) return L.preventDefault();
    i.onChange(t), c.mode === 0 && (i.closeListbox(), X().nextFrame(function () {
      var d;
      return (d = c.buttonRef.current) == null ? void 0 : d.focus({
        preventScroll: !0
      });
    }));
  }),
      S = T(function () {
    if (a) return i.goToOption(R.Nothing);
    i.goToOption(R.Specific, n);
  }),
      p = we(),
      l = T(function (L) {
    return p.update(L);
  }),
      x = T(function (L) {
    p.wasMoved(L) && (a || b || i.goToOption(R.Specific, n, 0));
  }),
      E = T(function (L) {
    p.wasMoved(L) && (a || b && i.goToOption(R.Nothing));
  }),
      W = h(function () {
    return {
      active: b,
      selected: A,
      disabled: a
    };
  }, [b, A, a]);
  return _({
    ourProps: {
      id: n,
      ref: g,
      role: "option",
      tabIndex: a === !0 ? void 0 : -1,
      "aria-disabled": a === !0 ? !0 : void 0,
      "aria-selected": A,
      disabled: void 0,
      onClick: v,
      onFocus: S,
      onPointerEnter: l,
      onMouseEnter: l,
      onPointerMove: x,
      onMouseMove: x,
      onPointerLeave: E,
      onMouseLeave: E
    },
    theirProps: u,
    slot: W,
    defaultTag: qe,
    name: "Listbox.Option"
  });
}

var Ze = w(Ve),
    et = w(Qe),
    tt = w(Xe),
    ot = w(Je),
    nt = w(Ye),
    Bt = Object.assign(Ze, {
  Button: et,
  Label: tt,
  Options: ot,
  Option: nt
});
export { Bt as Listbox };